export const routeModuleLoaders = {
    dashboard: () => import('./dashboard'),
    locationOverview: () => import('./location-overview'),
    handover: () => import('./handover'),
    residents: () => import('./residents'),
    residentDetail: () => import('./resident-detail'),
    sis: () => import('./sis'),
    wounds: () => import('./wounds'),
    woundDetail: () => import('./wound-detail'),
    woundApproval: () => import('./wound-approval'),
    medications: () => import('./medications'),
    admissions: () => import('./admissions'),
    occupancy: () => import('./occupancy'),
    inventory: () => import('./inventory'),
    schedule: () => import('./schedule'),
    inbox: () => import('./inbox'),
    contacts: () => import('./contacts'),
    practiceRequests: () => import('./practice-requests'),
    netzwerk: () => import('./netzwerk'),
    settings: () => import('./settings'),
    adminGlossary: () => import('./admin/glossary'),
    admissionPublic: () => import('./admission-public'),
    admissionInquiryPublic: () => import('./admission-inquiry-public'),
    inquiries: () => import('./inquiries'),
    familyPortalReceiver: () => import('./family-portal-receiver'),
    residentFamilyPortalHub: () => import('./resident-family-portal-hub'),
} as const;

export type PrefetchRouteKey = keyof typeof routeModuleLoaders;

export function resolvePrefetchRoute(path: string): PrefetchRouteKey | null {
    if (path.startsWith('/dashboard')) return 'dashboard';
    if (path.startsWith('/location-overview')) return 'locationOverview';
    if (path.startsWith('/handover')) return 'handover';
    if (path === '/residents') return 'residents';
    if (path.startsWith('/residents/')) return 'residentDetail';
    if (path.startsWith('/sis')) return 'sis';
    if (path === '/wounds') return 'wounds';
    if (path.startsWith('/wounds/approval')) return 'woundApproval';
    if (path.startsWith('/wounds/')) return 'woundDetail';
    if (path.startsWith('/medications')) return 'medications';
    if (path.startsWith('/admissions')) return 'admissions';
    if (path.startsWith('/inquiries')) return 'inquiries';
    if (path.startsWith('/occupancy')) return 'occupancy';
    if (path.startsWith('/inventory')) return 'inventory';
    if (path.startsWith('/schedule')) return 'schedule';
    if (path.startsWith('/inbox')) return 'inbox';
    if (path.startsWith('/contacts')) return 'contacts';
    if (path.startsWith('/practice-requests')) return 'practiceRequests';
    if (path.startsWith('/netzwerk')) return 'netzwerk';
    if (path.startsWith('/admin/glossary')) return 'adminGlossary';
    if (path.startsWith('/settings')) return 'settings';
    return null;
}

export function prefetchRoute(path: string) {
    const routeKey = resolvePrefetchRoute(path);
    if (!routeKey) return;

    void routeModuleLoaders[routeKey]();
}
